export const GET_ROUTER_LOADING = 'RouterLoading/get_router_loading'
export const SET_ROUTER_LOADING = 'RouterLoading/set_router_loading'